
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "email",
  "title": "Email Setup",
  "sidebar_label": "System Emails"
};
const slug = 'email';
const tableOfContents = [{
  "title": "Email Verification",
  "slug": "email-verification",
  "children": []
}, {
  "title": "Email Verification",
  "slug": "email-verification-1",
  "children": []
}, {
  "title": "Email Contents",
  "slug": "email-contents",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"email-verification"} nextElement={{
      "type": "paragraph"
    }}>Email Verification</_Heading>
    <p>{`If you are using email registration method, then an email address would be needed to use from address and reply to address. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Example: `}<a parentName="p" {...{
            "href": "mailto:contact@example.com"
          }}>{`contact@example.com`}</a>{`, `}<a parentName="p" {...{
            "href": "mailto:hello@example.com"
          }}>{`hello@example.com`}</a>{`, `}<a parentName="p" {...{
            "href": "mailto:support@example.com"
          }}>{`support@example.com`}</a>{` `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`A mandatory email that need to be verified with our email service provider. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`This email address will be used to send welcome email, OTP verification emails and also in future for listing approved, etc. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The system will email you when you update thi section, it has the steps to verify`}</p>
      </li>
    </ul>
    <p>{`Further reading if you are exploring why need to verify: `}<a parentName="p" {...{
        "href": "https://docs.aws.amazon.com/ses/latest/DeveloperGuide/verify-email-addresses.html?icmpid=docs_ses_console"
      }}>{`https://docs.aws.amazon.com/ses/latest/DeveloperGuide/verify-email-addresses.html?icmpid=docs_ses_console`}</a>{`
∂ß`}</p>
    <_Heading level={2} id={"email-verification-1"} nextElement={{
      "type": "paragraph"
    }}>Email Verification</_Heading>
    <p>{`In the onboarding call, we will do a verification with you from AWS console`}</p>
    <img src="/img/verify-email.png" alt="Email Verification" width="500" />
    <_Heading level={2} id={"email-contents"} nextElement={{
      "type": "paragraph"
    }}>Email Contents</_Heading>
    <p>{`Also you can customise the email messaging template from SuperAdmin
Contents for `}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Welcome Email `}</li>
      <li parentName="ol">{`OTP Email `}</li>
      <li parentName="ol">{`Reset Password Email `}</li>
      <li parentName="ol">{`Subscription Email`}</li>
    </ol>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Plus you can use merge-tags (Personalisation tokens where possible)`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
